<template>
  <div class="created-order-dialog" v-if="product.visa_product_id">
    <el-dialog
      class="add-order-modal"
      v-model="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="50%"
    >
      <div class="dialog-header">
        <div v-if="layout.pageHistory.length" class="header-back"  @click="goPrevPage">
          <img src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-dialog-back.png">
        </div>

        <div class="header-title">{{layout.pageConfig[page].title}}</div>
        <!-- 关闭 -->
        <div class="header-close" @click="innerVisible = false">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="dialog-body" v-if="innerVisible">
        <page-transtion
          :page="page"
          :transition-name="layout.transitionName"
        >
          <add-applicant
            v-if="page === 1"
            ref="addApplicant"
            :product="product"
            :depart-date.sync="formInfo.depart_date"
            :applicant-list.sync="formInfo.applicant_list"
            :offline.sync="formInfo.offline"
            :is-support-offline="isSupportOffline" 
            :holidays="otherInfo.holidays"
            :passportOrIDcard="passportOrIDcard"
            :isUniversalIdentity="isUniversalIdentity"
            :identityList="identityList"
            :submitting="layout.submitting"
            :ocrUploading="layout.ocrUploading"
            :otaOrderInfo="otaOrderInfo"
            :copyOrder="copyOrder"
            @go-next-page="goNextPage"
            @submit="submitCreatedOrder"
            @startUploadOcr="startUploadOcr"
            @share-product="$emit('share-product')"
          ></add-applicant>

          <offline-material-confirm
            v-if="page === 2"
            :product="product"
            :applicant-list="formInfo.applicant_list"
            :submitting="layout.submitting"
            @submit="submitCreatedOrder"
          ></offline-material-confirm>

          <select-history-applicant
            v-if="page === 3"
            :applicant-list.sync="formInfo.applicant_list"
            :identity-list="identityList"
            @back="goPrevPage"
          ></select-history-applicant>
        </page-transtion>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import addNewOrderService from '../../../services/add-new-order-service';
import AddApplicant from './components/add-applicant.vue';
import PageTranstion from './components/page-transtion.vue';
import orderingService from '../../../services/ordering-service';
import sensorsdata from 'sa-sdk-javascript';
import ExpressList from '../express-list';
import OfflineMaterialConfirm from './components/offline-material-confirm.vue';
import uploadFileService from '../../../services/upload-file-service.js';
import SelectHistoryApplicant from './components/select-history-applicant.vue';
import { fliggyOfflineFormCheck } from './components/ota/fliggy-offline-form-check';
import dayjs from 'dayjs';

export default {
  components: {
    AddApplicant,
    PageTranstion,
    ExpressList,
    OfflineMaterialConfirm,
    SelectHistoryApplicant,
  },
  props: {
    visible: Boolean,
    product: {
      type: Object,
      default() {
        return {};
      },
    },
    from: String,
    // 飞猪订单信息
    otaOrderInfo: Object,
    // 修改产品 原先叫复制订单 所以这里的变量名是copyorder默认直接调起申请人
    copyOrder: Object,
  },
  data() {
    return {
      layout: {
        pageConfig: {
          0: {
            ref: '',
            title: '资料递交方式',
          },
          1: {
            ref: 'addApplicant',
            title: '添加申请人',
          },
          2: {
            ref: '',
            title: '线下资料核对',
          },
          3: {
            ref: '',
            title: '历史申请人',
          },
        },
        pageHistory: [], // page历史，用于返回
        transitionName: 'slide-left', // 过渡动画样式
        submitting: false, // 提交loading
        ocrUploading: false, // ocr识别中
        preOffline: 0, // 之前选择是否是线下，如果是，则在下一步的时候清空信息
        fliggyHideOfflineTips: false,
      },
      page: 1, // 0: 选择身份(废弃了)，1：添加申请人，2：线下资料核对, 3: 批量导入名单
      formInfo: {
        offline: 0, // 是否是线下
        depart_date: '',
        applicant_list: [
          {},
        ],
      },
      otherInfo: {
        holidays: [], // 放假日历
      },
      modalHeight: '',
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    // 是否支持线下订单
    isSupportOffline() {
      return !!this.product.offline;
    },
    // 2：有护照，1：有身份证，0：都没有
    passportOrIDcard() {
      const { passportOrIDcard } = addNewOrderService.isHavePassportOrIDcard(this.product);
      return passportOrIDcard;
    },
    // 是否是通用身份
    isUniversalIdentity() {
      if (this.product && this.product.material && this.product.material[0]) {
        return this.product.material[0].identity_id === 5;
      }
      return false;
    },
    // 当前可选择的身份
    identityList() {
      return addNewOrderService.getIdentitys(this.product, this.formInfo.offline ? 3 : 0);
    },
  },
  watch: {
    innerVisible: {
      handler(value) {
        if (value) {
          this.init();
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    init() {
      if (!this.product.visa_product_id) return;
      this.page = 1;
      this.layout.pageHistory = [];
      if (this.copyOrder && this.copyOrder.applicant.length > 0) {
        this.initCopyOrderInfo();
      } else {
        this.layout.preOffline = 0;
        this.formInfo.depart_date = '';
        this.formInfo.offline = orderingService.isIncludePaperMaterialByRequiredMaterial(this.product) ? 1 : 0;
        this.formInfo.applicant_list = [{ identity_id: this.identityList.length === 1 ? this.identityList[0] : undefined }];
      }
      this.initOtaInfo();
      this.getOtherData();
    },
    // 初始化复制订单信息
    initCopyOrderInfo() {
      // 日期过期要自动清除
      this.formInfo.depart_date = this.copyOrder && dayjs(this.copyOrder.depart_date).isAfter(dayjs(), 'day') ? this.copyOrder.depart_date : '';
      this.formInfo.offline = this.copyOrder.offline;
      this.layout.preOffline = this.formInfo.offline;
      this.formInfo.applicant_list = this.copyOrder.applicant.map((ap) => {
        const defalutIdentityId = this.identityList.length === 1 ? this.identityList[0] : undefined;
        const currentIdentityId = this.identityList.includes(ap.identity_id) ? ap.identity_id : defalutIdentityId;
        return {
          identity_id: currentIdentityId,
          applicant_name: ap.applicant_name,
          applicant_id: this.copyOrder && this.copyOrder.applicant.length > 0 ? ap.order_applicant_id : undefined,
          show_error_applicant_name: true,
        };
      });
    },
    // 初始化飞猪信息
    initOtaInfo() {
      // 不是飞猪，直接不管
      if (!this.otaOrderInfo) return;
      // 存在说明是飞猪订单
      // 不支持线下，就选中线上
      this.formInfo.offline = this.isSupportOffline ? this.otaOrderInfo.ota_offline : 0;
      // 是否显示优先选择提示，如果不支持线下，但是是线下订单，则隐藏
      this.layout.fliggyHideOfflineTips = this.otaOrderInfo.ota_offline && !this.isSupportOffline;

      this.initOtaApplicants();
      
    },
    // 初始化OTA申请人信息
    initOtaApplicants() {
      // 不是飞猪，直接不管
      if (!this.otaOrderInfo) return;

      if (!this.otaOrderInfo.ota_offline && this.otaOrderInfo.applicants && this.otaOrderInfo.applicants.length) {
        // 线上订单，存在申请人，赋值进去
        this.formInfo.applicant_list = this.otaOrderInfo.applicants.map((item) => {
          const defalutIdentityId = this.identityList.length === 1 ? this.identityList[0] : undefined;
          const currentIdentityId = this.identityList.includes(item.identity_id) ? item.identity_id : defalutIdentityId;
          return {
            applicant_name: item.passport ? item.passport.fullname : '',
            identity_id: currentIdentityId,
            ota_apply_id: item.ota_apply_id,
            file_url: item.passport ? item.passport.url : '',
            ocr_status: item.passport && item.passport.fullname ? 2 : 3, // 识别成功还是失败
            ota_passport: item.passport,
          };
        });
      } else if (this.otaOrderInfo.ota_offline && this.otaOrderInfo.applicants && this.otaOrderInfo.applicants.length) {
        this.formInfo.applicant_list = this.otaOrderInfo.applicants.map(item => ({
          surname_pinyin: item.surname_pinyin,
          given_name_pinyin: item.given_name_pinyin,
          credential_no: item.credential_no,
          identity_id: this.identityList.length === 1 ? this.identityList[0] : undefined,
        }));
      } else {
        // 线下订单
        this.formInfo.applicant_list = [{ identity_id: this.identityList.length === 1 ? this.identityList[0] : undefined }];
      }
    },

    async getOtherData() {
      // 获取假日
      const res = await addNewOrderService.getProductHolidays(this.product.visa_country_id);
      this.otherInfo.holidays = res[this.product.visa_country_id] || [];
    },
    
    // 跳转下一页
    goNextPage(page) {
      if (this.page === page) return;
      this.layout.transitionName = 'slide-left';
      this.layout.pageHistory.push(this.page);
      this.page = page;
    },
    // 返回上一页
    async goPrevPage() {
      try {
        if (this.$refs[this.layout.pageConfig[this.page].ref] && this.$refs[this.layout.pageConfig[this.page].ref].customPageBack) {
          // 存在自定义返回函数，则先触发，成功才往下走
          await this.$refs[this.layout.pageConfig[this.page].ref].customPageBack(); 
        }
        if (!this.layout.pageHistory.length) return;
        this.layout.transitionName = 'slide-right';
        const prevPage = this.layout.pageHistory.pop();
        this.page = prevPage;

        // 更新前一页的offline
        this.layout.preOffline = this.formInfo.offline;
      } catch (error) {
        //
      }
    },

    // 提交线上线下页面，
    submitOfflinePage(page) {
      if (this.formInfo.offline !== this.layout.preOffline) {
        // 说明切换了线上线下，则清空申请人
        this.formInfo.depart_date = '';
        // 是否是飞猪订单
        if (this.otaOrderInfo) {
          this.initOtaApplicants();
        } else {
          this.formInfo.applicant_list = [{ identity_id: this.identityList.length === 1 ? this.identityList[0] : undefined }];
        }
      }
      this.goNextPage(page);
    },
    // 批量上传护照图片，每次五张五张来，防止同时太多
    // 为啥要放在这里，需要在返回的时候，还挂在后台识别
    startUploadOcr() {
      this.layout.ocrUploading = true;
      const list = this.formInfo.applicant_list.filter(item => item.ocr_status === 0);
      if (!list.length) {
        return;
      }

      this.loopRequestUploadOcr(list, () => {
        this.layout.ocrUploading = false;
        this.$message.info(`${this.passportOrIDcard === 2 ? '护照' : '身份证'}识别成功${list.filter(item => item.ocr_status === 2).length}人，失败${list.filter(item => item.ocr_status === 3).length}人`);
      });
    },

    // 批量上传护照图片，每次五张五张来，防止同时太多
    loopRequestUploadOcr(allList, callback) {
      const list = allList.filter(item => item.ocr_status === 0);
      if (!list.length) {
        callback && callback();
        return;
      }
      // 取前五个
      const waitList = list.slice(0, 10);
      Promise.all(waitList.map(async (item) => {
        this.$set(item, 'ocr_status', 1);
        try {
          const res = await uploadFileService.uploadOcrMaterial(
            item.file,
            this.passportOrIDcard === 2 ? 'passport' : 'idcarda',
          );
          if (res.cropped_image) {
            delete res.cropped_image;
          }

          if (!res.id_no && !res.fullname) {
            // 说明识别失败了
            this.$set(item, 'ocr_status', 3);
            // 报错出现
            this.$set(item, 'show_error_applicant_name', true);
            this.$set(item, 'show_error_identity_id', true);
            return;
          }
          // 识别成功
          this.$set(item, 'ocr_info', res);
          this.$set(item, 'applicant_name', res.fullname);
          this.$set(item, 'ocr_status', 2);
        } catch (error) {
          this.$set(item, 'ocr_status', 3);
        }
        // 报错出现
        this.$set(item, 'show_error_applicant_name', true);
        this.$set(item, 'show_error_identity_id', true);
      })).finally(() => {
        // 在下面五个
        this.loopRequestUploadOcr(allList, callback);
      });
    },

    // 飞猪线下订单校验
    checkParamsForFliggy() {
      for (let i = 0; i < this.formInfo.applicant_list.length; i++) {
        const item = this.formInfo.applicant_list[i];
        // 普通订单 fliggy-offline-applicant-form也有校验，请同步修改
        if (fliggyOfflineFormCheck.surname(item.surname)) {
          this.$message.error('有申请人姓(中文)填写错误，请检查');
          return false;
        }
        if (fliggyOfflineFormCheck.given_name(item.given_name)) {
          this.$message.error('有申请人名(中文)填写错误，请检查');
          return false;
        }
        if (fliggyOfflineFormCheck.surname_pinyin(item.surname_pinyin)) {
          this.$message.error('有申请人姓(拼音)填写错误，请检查');
          return false;
        }
        if (fliggyOfflineFormCheck.given_name_pinyin(item.given_name_pinyin)) {
          this.$message.error('有申请人名(拼音)填写错误，请检查');
          return false;
        }
        if (fliggyOfflineFormCheck.credential_no(item.credential_no)) {
          this.$message.error('有申请人护照号填写错误，请检查');
          return false;
        }

        if (!this.isUniversalIdentity) {
          if (fliggyOfflineFormCheck.identity_id(item.identity_id) || this.identityList.every(id => id !== item.identity_id)) {
            this.$message.error('有申请人身份未选择，请检查');
            return false;
          }
        }
      }
      return true;
    },
    // 检测申请人
    checkParams() {
      if (!this.formInfo.depart_date) {
        // 
        this.$message.error('请选择出行日期');
        return false;
      }
      // 飞猪线下订单
      if (this.otaOrderInfo && this.otaOrderInfo.ota_offline) {
        return this.checkParamsForFliggy();
      }
      for (let i = 0; i < this.formInfo.applicant_list.length; i++) {
        const item = this.formInfo.applicant_list[i];
        // 普通订单
        if (!item.applicant_name || item.applicant_name.trim().length < 2) {
          this.$message.error('有申请人姓名未填写，请检查');
          return false;
        }
        if (!this.isUniversalIdentity) {
          if (item.identity_id === undefined || this.identityList.every(id => id !== item.identity_id)) {
            this.$message.error('有申请人身份未选择，请检查');
            return false;
          }
        }
        
        if ([0, 1].includes(item.ocr_status)) {
          this.$message.error('申请人信息正在识别中，请稍后');
          return false;
        }
      }
      return true;
    },
    // 检查飞猪申请人
    async checkOtaInfoApplicantNum() {
      if (!this.otaOrderInfo) return;
      if (this.formInfo.applicant_list.length < this.otaOrderInfo.item_num) {
        let alertContent = '出行人数量小于飞猪订单商品数量，是否继续？后续仍然可以添加出行人';
        if (this.formInfo.offline) {
          alertContent = '出行人数量小于飞猪订单商品数量，是否继续？后续将无法添加出行人';
        }
        await this.$confirm(alertContent, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      }
      
    },
    async submitCreatedOrder() {
      try {
        
        if (this.layout.submitting) return;

        if (!this.checkParams()) {
          return;
        }

        if (this.page === 1) {
          await this.checkOtaInfoApplicantNum();
        }

        if (this.formInfo.offline && this.page === 1) {
          // 如果是线下订单，进入确认信息页
          this.goNextPage(2);
          return;
        }
        
        
        this.layout.submitting = true;
        
        const params = {
          depart_date: this.formInfo.depart_date,
          offline: this.formInfo.offline,
          visa_product_id: this.product.visa_product_id,
          ota_sub_order_id: this.otaOrderInfo ? this.otaOrderInfo.ota_sub_order_id : undefined,
          applicant_set: this.formInfo.applicant_list.map((item) => {
            // 线下，参数不一样
            if (this.otaOrderInfo && this.otaOrderInfo.ota_offline) {
              return {
                surname: item.surname,
                given_name: item.given_name,
                surname_pinyin: item.surname_pinyin,
                given_name_pinyin: item.given_name_pinyin,
                credential_no: item.credential_no,
                identity_id: this.isUniversalIdentity ? 5 : item.identity_id,
              };
            }
            const newItem = {
              applicant_name: item.applicant_name,
              identity_id: this.isUniversalIdentity ? 5 : item.identity_id,
              passport: item.ocr_status === 2 && this.passportOrIDcard === 2 ? item.ocr_info : undefined,
              id_card: item.ocr_status === 2 && this.passportOrIDcard === 1 ? item.ocr_info : undefined,
              ssq_archives_id: item.archives_id || undefined,
              applicant_id: item.applicant_id || undefined,
              ota_apply_id: item.ota_apply_id,
            };

            // 线上订单，直接用传入的护照信息
            if (this.otaOrderInfo) {
              newItem.passport = item.ota_passport;
            }
            return newItem;
          }),
        };
        const order = await (this.otaOrderInfo ? addNewOrderService.addFliggyOrder(params) : addNewOrderService.addOrder(params));
        this.layout.submitting = false;
        // 神策监控
        sensorsdata.track('StartVisaOrderConfirm', {
          source: this.from,
          country: order.country,
          visa_product_id: order.visa_product_id,
          product_name: order.product_name,
          visa_type: order.visa_type,
          depart_date: new Date(order.depart_date),
          user_order_id: order.user_order_id,
          applicant_num: order.applicant.length,
          offline: order.offline === 0 ? '线上' : '线下',
          user_type: '同业',
          need_online_application: Boolean(this.product.visa_application && this.product.visa_application.visa_application_id),
          need_interview: Boolean(this.product.need_interview || this.product.need_delivery),
        });
        // 线上线下不一样的处理
        const allSteps = orderingService.getOrderSteps(order);
        this.$router.push(allSteps[order.offline ? 1 : 0].routeConfig);
      } catch (error) {
        this.layout.submitting = false;
        console.log(error);
      }
    },
   

  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";

.created-order-dialog{
  .add-order-modal{
    /deep/ .el-dialog{
      width: 680px;
      border-radius: 5px;
      margin: 0;
      transform: translate(-50%, -50%);
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body{
        padding: 0;
      }
    }
    .dialog-header{
      padding: 0 20px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #E9EEF2;
      position: relative;
      .header-back {
        position: absolute;
        left: 24px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .header-title{
        font-size: 20px;
        color: #2f333d;
        font-weight: 600;
      }
      .header-close{
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        font-size: 15px;
        color: #91999F;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          color: @new-blue;
        }
      }
    }

  }
}


</style>



// WEBPACK FOOTER //
// src/components/add-order/created-order/created-order-dialog.vue